<template>
  <div class="tresult-tests" ref="tests">
    <div v-if="!mobileMode" class="tests-table">
      <div class="row-header">
        <el-select
          clearable
          v-model="selectedGroup"
          @clear="clearSelect"
          @change="changeGroup"
          placeholder="Группа"
        >
          <el-option
            v-for="(group, index) in groupList"
            :key="index"
            :label="group.name"
            :value="group.id"
          >
          </el-option>
        </el-select>
        <span class="tests-table__text"
          >Кол-во студентов, отвечавших на тест</span
        >
        <span class="tests-table__text">Аналитика теста</span>
        <span class="tests-table__text">Количество положительных оценок</span>
        <span class="tests-table__text">Количество отрицательных оценок</span>
        <span class="tests-table__text">Среднее время решения теста</span>
        <span class="tests-table__text">Статистика по группе</span>
        <span>Детальная статистика</span>
      </div>
      <div class="table__content">
        <div class="row" v-for="(test, index) of filtredTestList" :key="index">
          <span class="tests-table__text">{{ test.group_name }}</span>
          <span class="tests-table__text">{{ test.user_tested }}</span>
          <span
            class="tests-table__text"
            :style="{
              backgroundColor: testStatusColor(test.testDifficalty),
              color: 'white',
            }"
            >{{ test.testDifficalty }}</span
          >
          <span class="tests-table__text">{{ test.user_passed }}</span>
          <span class="tests-table__text">{{
            test.user_tested - test.user_passed
          }}</span>
          <span class="tests-table__text">{{ test.time_avrg }}</span>
          <button class="table__content-btn" @click="showGroupGtatistics(test)">
            <i class="fas fa-chart-line"></i>
          </button>
          <button
            class="table__content-btn"
            @click="showDetailedStatistics(test)"
          >
            <i class="fas fa-chart-pie"></i>
          </button>
        </div>
      </div>
    </div>
    <slider
      v-if="mobileMode"
      @next="updateCurrentSlide"
      @prev="updateCurrentSlide"
      ref="slider"
      :closeBtn="false"
    >
      <div
        class="slide__container"
        v-for="(test, index) of filtredTestList"
        :key="index"
      >
        <div class="slide">
          <div class="slide__header">
            <button
              :class="[
                'header__arrow-btn',
                { 'arrow-disble': curentSlide === 0 },
              ]"
              @click.stop="prev"
            >
              <i class="el-icon-arrow-left"></i>
            </button>
            <el-select
              clearable
              :value="test.group_name"
              @clear="clearSelect"
              @change="changeGroup"
              placeholder="Группа"
            >
              <el-option
                v-for="(group, index) in groupList"
                :key="index"
                :label="group.name"
                :value="group.id"
              >
              </el-option>
            </el-select>
            <button
              :class="[
                'header__arrow-btn',
                { 'arrow-disble': curentSlide === filtredTestList.length - 1 },
              ]"
              @click.stop="next"
            >
              <i class="el-icon-arrow-right"></i>
            </button>
          </div>
          <div class="slide__left-section">
            <span>Кол-во студентов, отвечавших на тест</span>
            <span>Аналитика теста</span>
            <span>Количество положительных оценок</span>
            <span>Количество отрицательных оценок</span>
            <span>Среднее время решения теста</span>
            <span>Статистика по группе</span>
            <span>Детальная статистика</span>
          </div>
          <div class="slide__right-section">
            <span>{{ test.user_tested }}</span>
            <span
              class="test-diff"
              :style="{
                backgroundColor: testStatusColor(test.testDifficalty),
                color: 'white',
              }"
              >{{ test.testDifficalty }}</span
            >
            <span>{{ test.user_passed }}</span>
            <span>{{ test.user_tested - test.user_passed }}</span>
            <span>{{ test.time_avrg }}</span>
            <button class="test-btn" @click="showGroupGtatistics(test)">
              <i class="fas fa-chart-line"></i>
            </button>
            <button class="test-btn" @click="showDetailedStatistics(test)">
              <i class="fas fa-chart-pie"></i>
            </button>
          </div>
        </div>
      </div>
    </slider>
  </div>
</template>

<script>
import slider from "@/components/slider";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      curentSlide: 0,
      groupList: [],
      selectedGroup: "",
      testList: [],
      filtredTestList: [],
    };
  },
  components: {
    slider,
  },
  computed: {
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },
  methods: {
    ...mapMutations(["setModalData"]),
    next() {
      this.$refs.slider.next();
    },
    prev() {
      this.$refs.slider.prev();
    },
    updateCurrentSlide(v) {
      this.curentSlide = v;
    },
    testStatusColor(value) {
      if (value == "Легкий") {
        return "#67C23A";
      } else if (value == "Нормальный") {
        return "#E6A23C";
      } else if (value == "Сложный") {
        return "#f56c6c";
      }
    },
    clearSelect() {
      this.filtredTestList = this.testList;
    },
    changeGroup(v) {
      this.filtredTestList = this.testList.filter((el) => el.group_id === v);
      this.curentSlide = 0;
      this.$refs.slider.goToSlide(this.curentSlide);
    },
    showGroupGtatistics(value) {
      if (value) {
        let obj = {
          name: "groupStatistic",
          data: value,
        };
        this.setModalData(obj);
      }
    },
    showDetailedStatistics(value) {
      if (value) {
        let obj = {
          name: "detailStatistic",
          data: value,
        };
        this.setModalData(obj);
      }
    },
    normalizeRequest(data) {
      let newData = [];
      data.forEach((el) => {
        let testName = el.name;
        let testId = el.tid;
        el.stats.forEach((element) => {
          element.test_name = testName;
          element.test_id = testId;
          newData.push(element);
        });
      });
      return newData;
    },
  },
  mounted() {
    this.axios
      .get(`api/results/${this.$route.params.did}/tresults`)
      .then((res) => {
        this.groupList = res.data.groups;
        this.testList = this.normalizeRequest(res.data.stats);
        this.filtredTestList = this.testList;
      });
  },
};
</script>

<style lang="scss">
.tresult-tests {
  height: 100%;
  position: relative;
  overflow: hidden;
  .tests-table {
    display: grid;
    grid-template-rows: max-content 1fr;
    color: $regular-text-clr;
    height: 100%;
    .row-header,
    .row {
      justify-items: center;
      align-items: center;
      display: grid;
      grid-template-columns: 20% 12% 10% 14% 10% 10% 10% 9%;
      font-size: 14px;
      column-gap: 5px;
      border-bottom: 1px solid $placeholder-text-clr;
      padding: 10px 0;
      .tests-table__text {
        text-align: center;
        padding: 5px;
        border-radius: 10px;
      }
    }
    .row-header {
      background-color: $basic-white;
      font-weight: bold;
    }
    .table__content {
      width: 100%;
      overflow-y: scroll;
      height: 100%;
    }
    .row {
      .table__content-btn {
        color: $secondary-text-clr;
        font-size: 20px;
        transition-duration: 0.3s;
        transition-property: color;
        &:hover {
          color: $brand-clr-1;
        }
      }
    }
  }
}
@media (max-width: 800px) {
  .tresult-tests {
    .slide {
      display: grid;
      grid-template-columns: 2fr 1fr;
      grid-template-rows: max-content 1fr;
      column-gap: 10px;
    }
    .slide__header {
      width: 100%;
      grid-column-start: 1;
      grid-column-end: 3;
      grid-row-start: 1;
      grid-row-end: 1;
      justify-self: center;
      padding: 10px 0;
      background-color: $brand-clr-1;
      display: grid;
      grid-template-columns: 40px 1fr 40px;
      justify-items: center;
    }
    .el-select {
      width: 100%;
      .el-icon-circle-close {
        font-size: 25px !important;
      }
    }

    .header__arrow-btn {
      font-weight: bold;
      color: $basic-white;
      padding: 0;
      i {
        font-size: 20px;
        font-weight: inherit;
      }
    }
    .arrow-disble {
      color: $primary-text-clr;
    }
    .slide__left-section {
      row-gap: 5px;
      font-weight: bold;
      height: 100%;
      align-items: center;
      display: grid;
      grid-template-rows: repeat(7, 1fr);
    }
    .slide__right-section {
      row-gap: 5px;
      height: 100%;
      align-items: center;
      display: grid;
      grid-template-rows: repeat(7, 1fr);
      span {
        text-align: center;
      }
    }
    .test-diff {
      padding: 5px;
      text-align: center;
      border-radius: 5px;
    }
    .test-btn {
      i {
        font-size: 22px;
      }
      color: #0288d1;
    }
  }
}
</style>